import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";
import store from "./store";
import { App } from "./App";
import "./css/theme.css";
import "./css/styles.css";
import "./css/responsive.css";
import Modal from "./shared/Modal";
import AppContextProvider from "./contexts/AppContext";
import AuthProvider from "./contexts/AuthContext";
import Toaster from "./components/Toaster";
import { googleClientId } from "./shared/const.prop";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <Provider store={store}>
        <BrowserRouter basename="/">
          <AppContextProvider>
            <AuthProvider>
              <Toaster />
              <App />
              <Modal />
            </AuthProvider>
          </AppContextProvider>
        </BrowserRouter>
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
